import React from "react";

import { useProfile } from "app/context";
import { ProgramLink, ProfileLink } from "app/links";

import ErrorBoundary from "components/common/ErrorBoundary";
import { ActionButton, Button, classnames, Icon } from "@culturehq/components";
import { Trans } from "app/utils";

const PersonCard = ({ person, onSelected, onUnselected, sortable }) => {
  const { profile } = useProfile();
  const { organization: { isEducational } } = profile;

  const selectProfile = () => {
    onSelected(person);
  };

  const unselectProfile = () => {
    onUnselected(person);
  };

  const classes = classnames(
    "PersonCard",
    "col-xs-12",
    "col-sm-6",
    "col-md-3",
    { PersonCard__Selected: person.selected }
  );

  return (
    <div className={classes} data-id={person.id}>
      <div className="people-list-item">
        <ErrorBoundary>
          <div className="col-xs-12 header">
            <ProfileLink user={person} className="link" target="_blank">
              <div
                className="profile-photo"
                style={{ backgroundImage: `url(${person.avatar.mediumUrl})` }}
              />
            </ProfileLink>
          </div>
          <div className="col-xs-12 body">
            <p className="name">
              <ProfileLink user={person} target="_blank" />
            </p>
            {!isEducational && (<p className="title">{person.title}</p>)}
            {isEducational && (
              <p className="PersonCard--program">
                {person.programs.map((program, index) => (
                  <span key={program.id}>
                    <ProgramLink program={program} />
                    {index !== person.programs.length - 1 && ", "}
                  </span>
                ))}
              </p>
            )}
          </div>
          <div className="col-xs-12 footer">
            {person.selected
              ? (
                <ActionButton className={classnames({ "disabled-button": sortable })} onClick={() => unselectProfile()} disabled={sortable}>
                  <Icon icon="checkmark" />
                  <Trans>Selected</Trans>
                </ActionButton>
              ) : (
                <Button onClick={() => selectProfile()}>
                  <Icon icon="ios-plus" />
                  <Trans>Select Profile</Trans>
                </Button>
              )}
          </div>
          {sortable && (
            <div className="sortable__drag-handler sortable__dragger">
              <Icon icon="drag" />
            </div>
          )}
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default PersonCard;
